<template>
<div>
  <div class="card mgb-20px">
    <header class="header-card">
      <p>{{ $t('informationsGenerationCode.titleMateriel') }}</p>
    </header>
    <div class="card-content">
      <div class="columns">
        <div class="column is-11 columns is-multiline">
          <div class="column is-3">
            <b-field :label="$t('informationsGenerationCode.label.codeDispositif')"
                     custom-class="has-text-weight-normal is-italic is-marginless">
              <router-link :to="{ name: 'c.gabed.emplacement-detailDispositif',
                                  params: { idDispositif: dispositif.id }}"
                 class="lien"
                 :class="checkPermissions(permEmplacement.lecture) ?
                        'has-text-weight-bold' : 'text-access-no-permission'">
                {{dispositif.code}}
              </router-link>
            </b-field>
          </div>
          <div class="column is-3">
            <b-field :label="$t('informationsGenerationCode.label.adresseDispositif')"
                     custom-class="has-text-weight-normal is-italic is-marginless">
              <span class="has-text-weight-bold">
                {{adresse}}
              </span>
            </b-field>
          </div>
          <div class="column is-3">
            <b-field :label="$t('informationsGenerationCode.label.inseeDispositif')"
                     custom-class="has-text-weight-normal is-italic is-marginless">
              <span class="has-text-weight-bold">
                {{dispositif.adresse.codeInsee}}
              </span>
            </b-field>
          </div>
        </div>
        <div v-if="treeLink" class="column is-1 level">
          <div class="level-right">
            <b-tooltip
              size="is-large"
              :label="$t('general.button.afficher')">
              <button
                class="button"
                :disabled="!checkPermissions(permEmplacement.lecture)"
                @click="$router.push({
                      name: 'c.gabed.emplacement-detailEmplacement',
                      params: { id: dispositif.emplacementId } })">
                <b-icon icon="file-tree" type="is-info"></b-icon>
              </button>
            </b-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { EMPLACEMENT } from '@/configuration/gabed/permissionsGabedConf';

const Permissions = createNamespacedHelpers('permissions');

export default {
  props: {
    element: {
      type: Object,
      required: true,
    },
    dispositif: {
      type: Object,
      required: true,
    },
    treeLink: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      permEmplacement: EMPLACEMENT,
    };
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    adresse() {
      const elementAdress = this.dispositif.adresse;
      let adresse = elementAdress.adresse1 || elementAdress.adresse2;
      if (elementAdress.codePostal) adresse += ' - ' + elementAdress.codePostal;
      if (elementAdress.ville) adresse += ' - ' + elementAdress.ville;
      return adresse;
    },
  },
};

</script>
